import ZkBreadcrumbItem from '../breadcrumb/src/breadcrumb-item'

/* istanbul ignore next */
ZkBreadcrumbItem.install = function(Vue) {
  Vue.component(ZkBreadcrumbItem.name, ZkBreadcrumbItem)
}

export default ZkBreadcrumbItem



// WEBPACK FOOTER //
// ./src/packages/breadcrumb-item/index.js